import React from 'react';
import { Hero } from './components/Hero';
import { Letter } from './components/Letter';
import { SevenDays } from './components/SevenDays';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { Method } from './components/Method';
import { Pricing } from './components/Pricing';
import { Imagine } from './components/Imagine';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2mmlt91jqfz37">
      <main data-id="element-1" data-mp="31aqdi9yfoio3">
        <Hero data-id="element-2" data-mp="31agpgrwy8ll1" />
        <Letter data-id="element-3" data-mp="31ayqe1uk3nza" />
        <SevenDays data-id="element-4" data-mp="31bic7tnbuwil" />
        <Bonuses data-id="element-5" data-mp="31c1jmgfcq2id" />
        <ForYou data-id="element-6" data-mp="31cjou2jzrr2f" />
        <Method data-id="element-7" data-mp="2wk9zooqpav17" />
        <Pricing data-id="element-8" data-mp="2wjqgz5t882m4" />
        <Imagine data-id="element-9" data-mp="2wj8dbo48im46" />
      </main>
      <Footer data-id="element-10" data-mp="2whxbhtucnofp" />
      <StickyBar data-id="element-11" data-mp="28ufqch5lbolp" />
    </div>;
}